
  export default {
    meta: {
      breadcrumbs: [['i18n/home', '/', 'mobile'], 'i18n/broadband'],
      metaTagOptions: { image: 'broadband' },
      product: 'broadband'
    },
    middleware: ['pages/products/broadband/index', 'breadcrumbs', 'meta-tags'],
    mounted () {
      this.$store.dispatch('matomo/trackIndexPageViewed', { name: 'Broadband index page viewed' });
    }
  };
